export default class Camelize {
  static camelKey(k) {
    return k
      .split('_')
      .map((s, i) => i ? s.charAt(0).toUpperCase() + s.slice(1) : s)
      .join('')
  }

  static camelObject(obj) {
    if (typeof obj !== 'object' || obj === null) {
      return obj
    }
    if (Array.isArray(obj)) {
      return obj.map(el => Camelize.camelObject(el))
    }
    return Object.keys(obj).reduce((result, key) => {
      result[Camelize.camelKey(key)] = Camelize.camelObject(obj[key])
      return result
    }, {})
  }

  static accountsFromDto(accounts) {
    return Camelize.camelObject(accounts)
  }

  static accountsExtendedItemFromDto(account, resourceId) {
    return {
      resourceId,
      transactions: Camelize.camelObject(account.transactions),
      balances: Camelize.camelObject(account.balances)
    }
  }

  static accountsExtendedFromDto(accounts) {
    return Object.keys(accounts).reduce((result, key) => {
      result[key] = Camelize.accountsExtendedItemFromDto(accounts[key], key)
      return result
    }, {})
  }

  static priceFromDto(price) {
    return Camelize.camelObject(price)
  }
}
